import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { Small } from 'foundations-components/transitional/components/Small';
import Loading from './Loading';
import { jsx as _jsx } from "react/jsx-runtime";
class DefaultHomeEditor extends Component {
  getDefaultHomeOptions() {
    const {
      defaultHomeOptions
    } = this.props;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    return defaultHomeOptions.map(({
      id,
      label,
      nonContextualLabel
    }) => ({
      text: nonContextualLabel || label,
      value: id
    }));
  }
  render() {
    const {
      defaultHome,
      defaultHomeOptions,
      attributesFetchLoading,
      attributesFetchFailed,
      updateDefaultHome
    } = this.props;
    if (attributesFetchLoading) {
      return /*#__PURE__*/_jsx(Loading, {});
    }
    if (attributesFetchFailed) {
      return /*#__PURE__*/_jsx(Small, {
        use: "error",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.errors.failedToLoadDefaultHome"
        })
      });
    }
    const defaultValue = defaultHome ?
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    defaultHomeOptions.find(({
      id
    }) => id === defaultHome) ? defaultHome : null : null;
    return /*#__PURE__*/_jsx(Select, {
      "data-test-id": "default-home-select",
      onChange: ({
        target: {
          value
        }
      }) => updateDefaultHome(value),
      options: this.getDefaultHomeOptions(),
      value: defaultValue,
      placeholder: I18n.text('userPreferences.homePage.placeholder')
    });
  }
}
DefaultHomeEditor.propTypes = {
  defaultHome: PropTypes.string,
  defaultHomeOptions: PropTypes.array,
  updateDefaultHome: PropTypes.func.isRequired,
  attributesFetchFailed: PropTypes.bool.isRequired,
  attributesFetchLoading: PropTypes.bool.isRequired
};
export default DefaultHomeEditor;